import { getAuthHeaders } from './utils';


export const fetchMyBookings = async () => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/my_bookings`, {
      headers: getAuthHeaders(),
    });

    if (!res.ok) {
      const error = await res.json();
      throw new Error(error.message || 'Failed to fetch bookings');
    }

    return res.json();
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
}


export const fetchMyPastBookings = async (year) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/my_past_bookings/${year}`, {
      headers: getAuthHeaders(),
    });

    if (!res.ok) {
      const error = await res.json();
      throw new Error(error.message || 'Failed to fetch past bookings');
    }

    return res.json();
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
}


export const fetchNextAvailableDates = async () => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/next_available_dates`, {
    headers: getAuthHeaders(),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Failed to fetch available dates');
  }

  return res.json();
};

export const fetchAvailableSpots = async (date) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/available_spots/${date}`, {
    headers: getAuthHeaders(),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Failed to fetch available spots');
  }

  return res.json();
};

export const bookSlotOther = async ({ date, userId = null, guestName = null, guestCompany = null }) => {
  const payload = { date, userId };
  
  if (guestName && guestCompany) {
    payload.guestName = guestName;
    payload.guestCompany = guestCompany;
  }

  const res = await fetch(`${process.env.REACT_APP_API_URL}/bookings/others`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Failed to book slot');
  }

  return res.json();
};

export const bookSlotSelf = async ({ date, slot_id = null }) => {
  const payload = { date };
  
  if (slot_id) {
    payload.slot_id = slot_id;
  }

  const res = await fetch(`${process.env.REACT_APP_API_URL}/bookings/self`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Failed to book slot');
  }

  return res.json();
};


export const deleteBooking = async (bookingId) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/bookings/${bookingId}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Failed to delete booking');
  }

  return res.json();
};

export const fetchOccupancyData = async (year) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/occupancy/${year}`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Failed to retrieve occupancy data');
  }

  return res.json();
};

export const fetchTodaysBookings = async () => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/todays_bookings`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Failed to retrieve today\'s bookings');
  }

  return res.json();
};

export const fetchBookingsByDate = async (date) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/bookings_by_date/${date}`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Failed to retrieve bookings data');
  }

  return res.json();
};

export const fetchCompanies = async () => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/bookings/companies`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Failed to retrieve companies list');
  }

  return res.json();
};

export const reportProblem = async (bookingId, numberPlate, comments) => {

  const payload = { 
          numberPlate, 
          comments 
        };

  const res = await fetch(`${process.env.REACT_APP_API_URL}/bookings/${bookingId}/report_problem`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Failed to report proglem for booking');
  }

  return res.json();
};

export const deleteReport = async (reportId) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/report_problem/${reportId}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.message || 'Failed to delete report');
  }
  return res.json();

};

export const createMySlotRelease = async ({ start_date, end_date = null }) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/slot_releases/self`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ start_date, end_date })
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.error || 'Failed to create release');
  }
  return data;
};

export const deleteMySlotRelease = async (release_id) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/slot_releases/self/${release_id}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.error || 'Failed to delete release');
  }
  return data;
};

export const fetchMySlotReleases = async (year) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/slot_releases/self/list/${year}`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.error || 'Failed to fetch releases');
  }
  return data;
};

export const fetchAssignedSlotBookedDates = async (year) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/slot_releases/self/booked/${year}`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.error || 'Failed to fetch assigned slot booked dates');
  }
  return data;
};

// Assignment report functions
export const createAssignmentReport = async (date, numberPlate, comments) => {
  const payload = { 
    date, 
    numberPlate, 
    comments 
  };

  const res = await fetch(`${process.env.REACT_APP_API_URL}/assignment_reports`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Failed to create assignment report');
  }

  return res.json();
};

export const deleteAssignmentReport = async (reportId) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/assignment_reports/${reportId}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Failed to delete assignment report');
  }
  
  return res.json();
};

export const fetchMyAssignmentReports = async () => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/assignment_reports/my`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  
  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Failed to fetch assignment reports');
  }
  
  return res.json();
};

// Admin reports APIs
export const fetchAllBookingReports = async () => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/reports/booking`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.error || 'Failed to fetch booking reports');
  }
  return data;
};

export const fetchAllAssignmentReports = async () => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/reports/assignments`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.error || 'Failed to fetch assignment reports');
  }
  return data;
};

export const fetchAllReports = async () => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/reports`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.error || 'Failed to fetch reports');
  }
  return data;
};
